import { AnswerSelectContainerProps } from '../config';
import { FC } from 'react';
import { IAnswerModel } from '../../../../state/stores/Question/AnswerModel';
import { SnapshotOut } from 'mobx-state-tree';
import { observer } from 'mobx-react';
import { useRegionInfo } from '../../../../hooks/useRegionInfo';
import { useStores } from '../../../../hooks/useStores';

const isNullish = (value: any): boolean => value === null || value === undefined;

const _ContainVideoLanguage : FC<AnswerSelectContainerProps> = ({
  question,
  onPress,
  children,
}) => {
  const rootStore = useStores();
  const {
    officeHourEndHour = 17,
    officeHourStartingHour = 9,
    endOfTheWeek = 5,
    beginningOfTheWeek = 1,
    videocallLanguages = [],
    videocallInfobox,
    error,
    loading,
  } = useRegionInfo();
  const instantHelpLabels = rootStore?.language?.translate.MOBILE?.ASSISTANCE?.INSTANT_HELP;
  const dayLabels = rootStore?.language?.translate.MOBILE?.SETTINGS?.NOTIFICATION?.DAYSOFWEEK;
  const theWeek: Record<number, string> = {
    0: dayLabels.DAY6,
    1: dayLabels.DAY0,
    2: dayLabels.DAY1,
    3: dayLabels.DAY2,
    4: dayLabels.DAY3,
    5: dayLabels.DAY4,
    6: dayLabels.DAY5,
  };
  const startDay = isNullish(beginningOfTheWeek)
    ? theWeek[1]
    : theWeek[beginningOfTheWeek];
  const endDay = isNullish(endOfTheWeek)
    ? theWeek[5]
    : theWeek[endOfTheWeek];

  const warning = videocallInfobox
    ? (instantHelpLabels?.OUTSIDE_OFFICE_HOURS as string)
      .replaceAll('{{startingHour}}', `${officeHourStartingHour}`)
      .replaceAll('{{endingHour}}', `${officeHourEndHour}`)
      .replaceAll('{{startDay}}', startDay)
      .replaceAll('{{endDay}}',  endDay)
    : undefined;

  const lastAnswer = question?.answers?.[0]? question.answers[0] : null;
  const answers = lastAnswer ? [lastAnswer] : [];
  answers.push(...videocallLanguages.map((language): SnapshotOut<IAnswerModel> => ({
    _id: language,
    key: language,
    wording: instantHelpLabels.LANGUAGES?.[language?.toUpperCase()],
    nextKey: null,
    featureChoice: null,
    meta: null,
    specialTypeOfAnswer: false,
  })));

  return children({
    answers: answers || [],
    questionId: question._id,
    questionKey: question.key,
    onPress,
    labels: {
      ERROR: error,
      WARNING: warning,
    },
    loading,
  });
};

export const ContainVideoLanguage = observer(_ContainVideoLanguage);

